import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts'
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { RosePieService } from './rose-pie.service'
import { initOpts } from '../../config/initOpts';
import { cloneDeep } from 'lodash';
import { ChartResizeService } from '../../service/chart-resize.service';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';

@Component({
  selector: 'bcac-rose-pie',
  templateUrl: './rose-pie.component.html',
  styleUrls: ['./rose-pie.component.scss']
})
export class RosePieComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private rosePieService: RosePieService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }
  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      if (this.chartInstance) {
        this.chartResizeService.autoPieResizeAdapt(this.chartInstance, this.chartOptions);
      }
    })
  }

  chartOptions: any = this.rosePieService.getDefaultOptionsOfRosePieChart();

  _bcacChartTitle: { label: string, show: boolean } = { label: "图表标题", show: true }

  // 标题是否显示
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }

  // 标题文本
  @Input()
  set bcacChartTitleText(label: string) {
    this._bcacChartTitle.label = label;
    this._bcacChartFileName = this._bcacChartTitle.label;
  }
  // 图片文件名
  _bcacChartFileName: string = "图表名"
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(bcacChartLoading: boolean) {
    this._bcacChartLoading = bcacChartLoading;
  }
  // 设置是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {

    this.rosePieService.changeToolboxShow(this.chartOptions, show);
    this.updateOptions()
  }
  // 设置饼图的半径
  @Input()
  set bcacPieChartRadius(bcacPieChartRadius: Array<string> | Array<number>) {
    this.rosePieService.changeRadius(this.chartOptions, bcacPieChartRadius);
    this.updateOptions();
  }
  // 设置饼图中心位置
  @Input()
  set bcacPieChartCenter(bcacPieChartCenter: Array<string> | Array<number>) {
    this.rosePieService.changeCenter(this.chartOptions, bcacPieChartCenter);
    this.updateOptions();
  }
  // 设置玫瑰图模式
  @Input()
  set bcacPieChartRoseType(bcacRoseType: 'radius' | 'area') {
    this.rosePieService.changePieChartRoseType(this.chartOptions, bcacRoseType)
    this.updateOptions()
  }
  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = []
  // 数据选择区域
  @Input()
  set bcacSelectList(selectList: { value: string | number, optList: { label: string, value: any }[] }[]) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && (selectList[0].hasOwnProperty('value') && selectList[0].hasOwnProperty('optList'))) {
        this._selectList = selectList;
      } else {
        selectList = [];
        this._selectList = selectList;
      }
    } else {
      selectList = [];
      this._selectList = selectList;
    }
  }

  @Input()
  set bcacLabelType(type: 'value' | 'percent') {
    this.rosePieService.changeLabelType(this.chartOptions, type);
    this.updateOptions();
  }


  bcacData: any = null;
  isNotSingleData: boolean = false;
  // 设置数据
  @Input()
  set bcacChartData(chartData: any[]) {
    if (chartData && Array.isArray(chartData)) {
      this.bcacData = chartData;
      let legendDataArr = [];
      chartData.forEach(e => {
        legendDataArr.push(
          {
            label: e.name,
            value: e.name,
            checked: true
          }
        );
      });
      this.legendDataArr = legendDataArr;
      this.rosePieService.changeChartData(this.chartOptions, chartData)
      // if (this.isDarkMode === true) {
      //   this.chartDarkModeService.openPieDarkMode(this.chartOptions, this.isDarkMode);
      // }
    }
    this.updateOptions();
  }

  legendChange(e) {
    this.rosePieService.topLegendChange(e, this.chartInstance);
  }
  // 设置系列名
  @Input()
  set bcacChartSeriesName(bcacChartSeriesName: string) {
    this.rosePieService.changeSeriesName(this.chartOptions, bcacChartSeriesName);
    this.updateOptions();
  }
  // 设置labelLine Length 第一段视觉引导线
  @Input()
  set bcacLabelLineLength(bcacLabelLineLength: number) {
    this.rosePieService.changeLabelLineLength(this.chartOptions, bcacLabelLineLength)
    this.updateOptions();
  }
  // 设置labelLine length2 第二段视觉引导线长度
  @Input()
  set bcacLabelLineLength2(bcacLabelLineLength2: number) {
    this.rosePieService.changeLabelLineLength2(this.chartOptions, bcacLabelLineLength2)
    this.updateOptions();
  }
  //更改legend位置
  // @Input()
  // set bcacLegendPosition(legendPosition) {
  //   this.rosePieService.changeLegendPosition(this.chartOptions, legendPosition)
  //   this.updateOptions()
  // }
  // 更改legend显示状态
  @Input()
  set bcacChartShowLegend(showLegend: boolean) {
    this.rosePieService.changeLegendShowStatus(this.chartOptions, showLegend)
    this.updateOptions()
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter()

  @Output() bcacDataSourceChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  chartInstance: ECharts = null;
  onOptionInit(ec) {
    this.chartInstance = ec;
    this.bcacGetChartInstance.emit(ec);
  }

  updateOptions() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.chartOptions, true);
    }
  }

  // sourceList: { name: string, value: string }[] = [];

  selectedData: string = "";

  // 选择不同的数据源
  selectedDataChange($event) {
    this.bcacData.forEach(element => {
      if (element.name === $event) {
        this.rosePieService.changeChartData(this.chartOptions, element.data);
        this.updateOptions();
        return;
      }
    });
  }
  // 数据源变更
  selectedModelChange($event) {
    this.bcacDataSourceChange.emit($event)
  }

  customToolBoxRightPosition = "3.5rem";
  @Input()
  set bcacCustomToolBoxRightPosition(value: string) {
    // this.customToolBoxRightPosition = value;
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  // 图标题 （ECharts自带标题）
  _chartTitle = ""
  @Input()
  set bcacTitle(title: string) {
    this._chartTitle = title;
    this.rosePieService.changeTitleOption(this.chartOptions, this._chartTitle)
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }
  legendDataArr = [];
  legendPosition = "bottom";
  @Input()
  set bcacLegendPosition(value: string) {
    this.legendPosition = value;
    this.rosePieService.setLegendPosition(this.chartOptions, this.legendPosition)
    this.updateOptions();
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.rosePieService.openRosePieSmallMode(this.chartOptions, this.isSmallMode, this.legendPosition)
      // this.chartResizeService.openRosePieSmallMode(this.chartOptions, this.isSmallMode, this.legendPosition);
      this.updateOptions();
    } else {
      this.isSmallMode = false;
    }
  }

  cardPadding = "1rem";
  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }

  isDarkMode: boolean | string = false;
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.isDarkMode = darkMode;
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openPieDarkMode(this.chartOptions, darkMode);
    this.updateOptions();
  }

  chartTitleColor = '';
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = color.darkModeTextColor;
    }
  }

  cardBgColor = "#fff";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }

  @Input()
  set bcacColors(chartColors) {
    this.commonService.changeChartColors(this.chartOptions, chartColors)
  }
  // 显示label
  @Input()
  set bcacLabelShow(labelShow: boolean) {
    this.rosePieService.changeLabelShowStatus(this.chartOptions, labelShow)
  }
  // 改变label对齐方式
  @Input()
  set bcacLabelAlignTo(alignTo: 'none' | 'labelLine' | 'edge') {
    this.rosePieService.changeLabelAlignTo(this.chartOptions, alignTo);
    this.updateOptions();
  }
  // 文字边距
  @Input()
  set bcacLabelMargin(margin: number | string) {
    this.rosePieService.changeLabelMargin(this.chartOptions, margin);
    this.updateOptions();
  }
  // 文字出血线
  @Input()
  set bcacLabelBleedMargin(bleedMargin: number) {
    this.rosePieService.changeLabelBleedMargin(this.chartOptions, bleedMargin);
    this.updateOptions();
  }

}
